import { useState, useEffect } from "react";

import {
  Card,
  Divider,
  Grid,
  Button,
  CardContent,
  TablePagination,
  CardActions,
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,

} from "@mui/material";
import _ from "lodash";

import { Typography, Dialog, DialogContent, DialogTitle } from '@mui/material';
import AddCircle from "@mui/icons-material/AddCircleOutline";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { ReactComponent as Add } from "assets/svgs/Add.svg";
import CustomBreadcrumbs from "components/Breadcrumbs";
// import NewProduct from "./NewProduct";
import axiosInstance from "configs/axiosConfig";
import {
  APIRouteConstants,
  dashboardRouteConstants,
} from "constants/routeConstants";
import Loader from "components/Loader";
import TableWithAction from "components/Tables/TableWithAction";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/system";
import { useSnackbar } from "notistack";
import CloudUpload from "@mui/icons-material/CloudUpload";
import CloseIcon from '@mui/icons-material/Close';
import { BULK_UPLOAD_PRODUCTS_SAMPLE_URL } from "constants/appConstants";
import getUser from "reducers/userDetails";
import { updateUserDetail } from "utils/auth";
import { format, differenceInDays } from "date-fns"; // For formatting dates
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"; // Calendar Icon
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { orderStatus } from 'constants/appData/filters';
import SearchInput from 'components/Search';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import DatePicker from "react-datepicker";
const InventoryReport = ({ breadcrumbs }) => {
//   const [isNewProduct, setNewProduct] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [isEditProduct, setEditProduct] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();
  const [loader, setLoader] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [productId, setSelectedProductId] = useState();
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const loggedInUser = useSelector((state) => state.userDetails);
  const location = useLocation();
  const { user } = loggedInUser;
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [searchString, setSearchString] = useState('');
  const [status, setOrderStatus] = useState('');
  const [allProductsDownload, setProductsListDownload] = useState([]);
  const [allOrders, setOrderList] = useState([]);
  const [salesSummary, setSalesSummary] = useState({});
  const [allOrdersDownload, setOrderListDownload] = useState([]);

  const handleDateChange = (update) => {
    if (update[0] && update[1]) {
        const daysDifference = differenceInDays(update[1], update[0]);

        if (daysDifference > 30) {
            // alert("You can only select a maximum duration of 30 days.");
            enqueueSnackbar("You can only select a maximum duration of 30 days.", { variant: "error" });
            return;
        }
    }
    setDateRange(update);
};

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedFile(null);
  };

  // const handleFileChange = (event) => {
  //     setSelectedFile(event.target.files[0]);
  // };
  useEffect(() => {
    if (location && location.state) {
      const { productId } = location.state;
      setSelectedProductId(productId);
    }
  }, [location]);


//   const getOrderList = async () => {
//     console.log('Start Date', startDate && format(startDate, "yyyy-MM-dd"));
//     setLoader(true);
//     let res = await axiosInstance.get(APIRouteConstants.STORE.ALL_ORDERS, {
//         params: {
//             // page: pageCount + 1,
//             search: searchString,
//             status: status,
//             paginate: true,
//             from_date: startDate && format(startDate, "yyyy-MM-dd"),
//             to_date: endDate && format(endDate, "yyyy-MM-dd")
//         },
//     });

//     if (res === false) {
//         setLoader(false);
//         return;
//     }

//     const { data } = res;

//     if (data) {
//         setOrderList(data.results);
//         setTotalCount(data.count);
//         // DO NOT clear searchString here
//     }

//     setLoader(false);
// };


const getProductListDownload = async () => {
    setLoader(true);

    // First, call getOrderList to refresh the current list
await getProductList();

    let res = await axiosInstance.get(APIRouteConstants.STORE.ALL_PRODUCTS, {
        params: {
            // page: pageCount + 1,
            search: searchString, // Uses same search string
            // status: status,
            paginate: false,
            from_date: startDate && format(startDate, "yyyy-MM-dd"),
            to_date: endDate && format(endDate, "yyyy-MM-dd")
        },
    });

    if (res === false) {
        setLoader(false);
        return;
    }

    const { data } = res;

    if (data) {
        setOrderListDownload(data);
        setTotalCount(data.length);
        // DO NOT clear searchString here either
        console.log('start dateeeee console', startDate, endDate);
        setLoader(false);
        return data;
    }

    // setLoader(false);
    // let { data, response } = res;

    // if (data) {
    //   setTotalCount(data.count);
    //   setPageCount(data.current_page - 1);
    //   setLoader(false);
    //   return data; // Return the results directly
    // }
    // setLoader(false);
};

  const getProductList = async () => {
    setLoader(true);
    let res = await axiosInstance.get(APIRouteConstants.STORE.ALL_PRODUCTS, {
        params: {
            page: pageCount + 1,
            search: searchString,
            // status: status,
            paginate: true,
            from_date: startDate && format(startDate, "yyyy-MM-dd"),
            to_date: endDate && format(endDate, "yyyy-MM-dd")
        },
    });
    if (res === false) {
      setLoader(false);
      return
    }
    let { data, response } = res;

    if (data && data.results && data.results.length) {
      setAllProducts(data.results);
      setTotalCount(data.count);
      setPageCount(data.current_page - 1);
      setLoader(false);
    }
    setLoader(false);
  };

//   const downloadExcel = async () => {
//     if (startDate == null || endDate == null) return;

//     try {
//         const allProductsDownload = await getProductListDownload(searchString);

//         if (!allProductsDownload || allProductsDownload.length === 0) {
//             enqueueSnackbar("No data available for the selected date range.", { variant: "error" });
//             return;
//         }

//         const modifiedOrders = allProductsDownload.map(({ name, category_name, sku, price, count }) => ({
//             product_name: name || "",
//             category_name: category_name || "",
//             sku_id: sku || "",
//             price: price ?? "",
//             inventory_count: count ?? "",
//         }));

//         const headers = ["product_name", "category_name", "sku_id", "price", "inventory_count"];

//         const orderWorksheet = XLSX.utils.json_to_sheet(modifiedOrders, { header: headers });

//         orderWorksheet['!cols'] = headers.map(key => ({
//             wch: Math.max(
//                 key.length,
//                 ...modifiedOrders.map(row => (row[key] ? row[key].toString().length : 0))
//             )
//         }));

//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, orderWorksheet, "Products");

//         const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//         const dataBlob = new Blob([excelBuffer], {
//             type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//         });
//         saveAs(dataBlob, "products.xlsx");

//     } catch (error) {
//         console.error("Error downloading Excel:", error);
//         enqueueSnackbar("Failed to download Excel", { variant: "error" });
//     }
// };


const downloadExcel = async () => {
    try {
        const allProductsDownload = await getProductListDownload(searchString);

        if (!allProductsDownload || allProductsDownload.length === 0) {
            enqueueSnackbar("No data available for the given search.", { variant: "error" });
            return;
        }

        const modifiedOrders = allProductsDownload.map(({ name, category_name, sku, price, count }) => ({
            product_name: name || "",
            category_name: category_name || "",
            sku_id: sku || "",
            price: price ?? "",
            inventory_count: count ?? "",
        }));

        const headers = ["product_name", "category_name", "sku_id", "price", "inventory_count"];

        const orderWorksheet = XLSX.utils.json_to_sheet(modifiedOrders, { header: headers });

        orderWorksheet['!cols'] = headers.map(key => ({
            wch: Math.max(
                key.length,
                ...modifiedOrders.map(row => (row[key] ? row[key].toString().length : 0))
            )
        }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, orderWorksheet, "Products");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const dataBlob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        saveAs(dataBlob, "products.xlsx");

    } catch (error) {
        console.error("Error downloading Excel:", error);
        enqueueSnackbar("Failed to download Excel.", { variant: "error" });
    }
};






const getSalesReport = async () => {
    let res = await axiosInstance.get(APIRouteConstants.STORE.SALES_ANALYTICS)
    if (res === false) {
        setLoader(false);
        return
    }

    let { data, response } = res;

    if (data) {
        setSalesSummary(data)
        setLoader(false);
        return data
    }
    setLoader(false);
}


  const refreshProduct = () => {
    // setNewProduct(false);
    setSelectedProduct("");
    setEditProduct(false);
    getProductList();
  };

  const handleEdit = (product) => {
    try {
      setSelectedProduct(product.id);
      setEditProduct(true);
      console.log("productid", product.id);
    } catch (error) {
      console.error("error while id", error);
    }
  };

  const handleChangePage = (e, page) => {
    setPageCount(page);
  };
  const getUser = async () => {
    let res = await axiosInstance.get(APIRouteConstants.AUTH.ME)
    if (res === false) {
      setLoader(false);
      return
    }
    let { data, response } = res;

    if (data && data.success) {
      const user = data.data;
      updateUserDetail(user)
    }
    setLoader(false);
  }
  useEffect(() => {
    getProductList();
    getUser();
  }, [pageCount]);

  useEffect(() => {
    if (productId) {
      setSelectedProduct(productId);
      setEditProduct(true);
    }
  }, [productId]);

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      console.log("filename", selectedFile);
      setFileName(selectedFile?.name);
      setFile(selectedFile);
    } else {
      setFileName("");
      setFile(null);
    }
  };

  const handleFileUpload = async () => {
    setLoader(true);
    if (!file) {
      console.error("No file selected for upload");
      enqueueSnackbar("No file selected for upload", { variant: "error" });
      setLoader(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axiosInstance.post(
        APIRouteConstants.STORE.UPLOAD_BULK_PRODUCTS,
        formData
      );
      if (response === false) {
        setLoader(false);
        return
      }

      if (response.status) {
        enqueueSnackbar("Products uploaded successfully", {
          variant: "success",
        });
        setOpen(false)
        getProductList()
      } else {
        setFileName("")
        setFile(null)
        setOpen(false)
        enqueueSnackbar(response.response?.data?.error, { variant: "error" });
      }
      setLoader(false);
    } catch (error) {
      enqueueSnackbar("something went wrong", { variant: "error" });
      setLoader(false);
    }
  };
  const handleDeleteProduct = async (product) => {
    setLoader(true);

    try {
      const response = await axiosInstance.post(
        APIRouteConstants.STORE.DELETE_PRODUCT(product.id),
      );
      if (response === false) {
        setLoader(false);
        return
      }
      console.log("product", response)
      if (response.status === 200) {
        enqueueSnackbar(response?.data?.message, {
          variant: "success",
        });

        getProductList()
      } else {
        enqueueSnackbar(response.response?.data?.error, { variant: "error" });
      }
      setLoader(false);
    } catch (error) {
      enqueueSnackbar("something went wrong", { variant: "error" });
      setLoader(false);
    }
  };

  return (
    <div className="store-analytics-wrapper website-analytics-wrapper">
      <Loader open={loader} />
      <div className="breadcrumb-wrapper">
        <CustomBreadcrumbs list={breadcrumbs} name={"Inventory Report"} />
      </div>
      {/* {isNewProduct ? (
        <NewProduct
          discardNewProduct={refreshProduct}
          allCategories={allCategories}
        />
      ) : (
        ""
      )} */}
      {/* {isEditProduct ? (
        <NewProduct
          discardNewProduct={refreshProduct}
          productId={selectedProduct}
          allCategories={allCategories}
        />
      ) : (
        ""
      )} */}
      { 
      (
        <Grid container className="component-grid">
          <Grid item xs={12}>
            <Card className="list-wrapper dashboard-card-wrapper">
              <CardContent>
                <div className="header-wrapper header-flex">
                  <span className="header-text">Inventory Report</span>
                  <div className="header-wrapper_category"></div>
                
                </div>
                <Divider />
                <div className='content-wrapper content-flex'>
                                    <span className='content-text'>
                                        {/* You can manage your customer orders here. Below you will see a list of your current orders based on their status, you can see whether an order is placed, whether it has been paid for and whether or not you have shipped the order to the customer. You can manage each order by clicking on the “Manage” order button. You can filter orders using the filter control, alternatively you can also search for orders by customer name or email address. */}
                                        Download excel sheet on the basis of date range
                                    </span>
                                </div>

                                {/* <Grid
                                    item
                                    md={6}
                                    sm={8}
                                    xs={12}
                                    display="flex"
                                    alignItems="center" // Align items in center
                                    // justifyContent="center" // Center the grid
                                    gap={1.5} // Reduce gap slightly
                                    // sx={{ margin: "0 auto", textAlign: "center" }} // Center the grid horizontally
                                    style={{ marginTop: "40px", marginBottom: "20px" }}
                                >
                                   
                                    <Box position="relative" sx={{ height: "38px" }}> 
                                        <DatePicker
                                            selectsRange
                                            startDate={startDate}
                                            endDate={endDate}
                                            onChange={handleDateChange}
                                            isClearable
                                            dateFormat="dd/MM/yy"
                                            placeholderText="Select date range"
                                            popperClassName="date-picker-popper"
                                            customInput={
                                                <TextField
                                                    label="Date Range"
                                                    size="small"
                                                    fullWidth
                                                    sx={{
                                                        height: "38px",
                                                        "& .MuiInputBase-root": { height: "40px", color: "black" }, // Set text color to gray
                                                        "& .MuiInputLabel-root": { top: "-5px", color: "gray" }, // Set label color to gray
                                                    }}
                                                    InputProps={{
                                                        readOnly: true, // Prevents user typing in input
                                                        endAdornment: (
                                                            <IconButton sx={{ marginRight: startDate ? "10px" : "" }}>
                                                                <CalendarTodayIcon fontSize="small" />
                                                            </IconButton>
                                                        ),
                                                    }}
                                                    style={{ fontSize: "0.6rem" }}
                                                />
                                            }
                                        />

                                        {startDate && endDate && (
                                            <Typography variant="body2" sx={{ mt: 0.5, color: "gray", textAlign: "center" }}>
                                                Date Format: dd/mm/yy
                                            </Typography>
                                        )}

                                    </Box>

                                    <style>
                                        {`
                                            .date-picker-popper {
                                                z-index: 1500 !important;
                                            }
                                        `}
                                    </style>
                                    <Button
                                        // sx={{
                                        //     width: { xs: "38vw", sm: "9vw", md: "12vw" },
                                        //     height: "40px", // Same height as Date Picker
                                        //     backgroundColor: "black",
                                        //     color: "white",
                                        //     fontSize: "12px",
                                        //     padding: "5px 10px", // Adjust padding for smaller size
                                        //     "&:hover": {
                                        //         backgroundColor: "#333",
                                        //     },
                                        // }}
                                        sx={{
                                            width: { xs: "38vw", sm: "9vw", md: "12vw" },
                                            height: "40px",
                                            backgroundColor: (startDate && endDate) ? "green" : "black",
                                            color: "white",
                                            fontSize: "12px",
                                            padding: "5px 10px",
                                            "&:hover": {
                                              backgroundColor: (startDate && endDate) ? "#218739" : "#333",
                                            },
                                          }}
                                        // disabled={startDate === null || endDate === null}
                                        onClick={downloadExcel}
                                        variant="contained"
                                    >
                                        📄 <span style={{ fontSize: "14px", marginLeft: "3px" }}> Download Excel </span>
                                    </Button>
                                </Grid> */}
                                

                                <div className='content-wrapper content-flex'  >
                                    <Grid container className='filter-wrapper' >
                                        <Grid item md={2} sm={2} xs={4}>
                                            <span className='detail-sec-text'>
                                                Filter by:
                                            </span>
                                        </Grid>
                                        {/* <Grid item sm={2} className='select-wrapper'>
                                    <FormControl fullWidth>
                                        <InputLabel size="small" id="demo-simple-select-label">Payment Status</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={paymentStatus}
                                            label="Payment Status"
                                            size="small"
                                            onChange={e => {
                                                setPaymentStatus(e.target.value)
                                                getOrderList()
                                            }}
                                        >
                                            <MenuItem value={''}>All</MenuItem>
                                            <MenuItem value={'processing'}>Processing</MenuItem>
                                            <MenuItem value={'complete'}>Complete</MenuItem>
                                            <MenuItem value={'cancelled'}>Cancelled</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid> */}

                                        {/* <Grid item md={4} sm={1} xs={12} /> */}
                                        <Grid item md={4} sm={6} xs={12} className='content-flex content-flex-right'>
                                            <SearchInput
                                                value={searchString}
                                                onChange={(e) => {
                                                    setSearchString(e.target.value)

                                                }}
                                                style={{ fontSize: '14px' }}
                                                onEnter={getProductList}
                                            // onBlur={getOrderList}
                                            />
                                        </Grid>
                                        {/* <Grid item md={4} sm={1} xs={12} /> */}
                                        <Button
                                        // sx={{
                                        //     width: { xs: "38vw", sm: "9vw", md: "12vw" },
                                        //     height: "40px", // Same height as Date Picker
                                        //     backgroundColor: "black",
                                        //     color: "white",
                                        //     fontSize: "12px",
                                        //     padding: "5px 10px", // Adjust padding for smaller size
                                        //     "&:hover": {
                                        //         backgroundColor: "#333",
                                        //     },
                                        // }}
                                        sx={{
                                            width: { xs: "38vw", sm: "9vw", md: "12vw" },
                                            height: "40px",
                                            backgroundColor: (startDate && endDate) ? "green" : "black",
                                            color: "white",
                                            fontSize: "12px",
                                            padding: "5px 10px",
                                            "&:hover": {
                                              backgroundColor: (startDate && endDate) ? "#218739" : "#333",
                                            },
                                          }}
                                        // disabled={startDate === null || endDate === null}
                                        onClick={downloadExcel}
                                        variant="contained"
                                    >
                                        📄 <span style={{ fontSize: "14px", marginLeft: "3px" }}> Download Excel </span>
                                    </Button>
                               
                                    </Grid>


                                </div>

                {loader === false && allProducts.length === 0 ? (
                  <div className="content-wrapper content-flex content-flex-center">
                    <Add />
                    <div className="detail-action-wrapper content-flex content-flex-center">
                      <span className="detail-text">
                        Start adding products to your store
                      </span>
                      <br />
                      <p className="detail-sec-text">
                        The product section is where you will find and manage
                        all the products in your store.
                        <br />
                        Please make sure you have added category and warehouse
                        delivery address before adding product.
                      </p>
                      <div className="button-wrapper">
                        <Button
                        //   onClick={() => setNewProduct(true)}
                          disabled={
                            _.isEmpty(user)
                              ? true
                              : !(user.is_category && user.warehouse_exist)
                          }
                          variant="contained"
                          color="secondary"
                          startIcon={<AddCircle />}
                        >
                          Add Product
                        </Button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Grid
                    container
                    className="dashboard-table-container"
                    spacing={4}
                    wrap="wrap"
                  >
                    <Grid item md={12} sm={12}>
                      <TableWithAction
                        isEdit={false}
                        domain={"product"}
                        rows={allProducts}
                        headers={[
                          {
                            label: "Product Name",
                            name: "name",
                            width: "27%",
                          },
                          {
                            label: "Category",
                            name: "category_name",
                            width: "10%",
                          },{
                            label: "SKU ID",
                            name: "sku",
                            width: "10%",
                          },
                          {
                            label: "Price",
                            name: "price",
                            width: "10%",
                          },
                          {
                            label: 'Inventory Count',
                            name: 'count',
                            width: '12%'
                        },
                        ]}
                        handleEdit={handleEdit}
                        handleDeleteProduct={handleDeleteProduct}
                      />
                      <TablePagination
                        rowsPerPageOptions={[]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={totalCount < 10 ? totalCount : 10}
                        page={pageCount}
                        onPageChange={handleChangePage}
                      />
                    </Grid>
                  </Grid>
                )}
              </CardContent>
              {!user?.isPublished ? (
                <CardActions className="footer-wrapper">
                  <div className="action-wrapper">
                    <Button
                      variant="outlined"
                      color="secondary"
                      style={{ backgroundColor: "white" }}
                      onClick={() => {
                        navigate(dashboardRouteConstants.HOME);
                      }}
                    >
                      Next {">"}
                    </Button>
                  </div>
                </CardActions>
              ) : (
                ""
              )}
            </Card>
          </Grid>
        </Grid>
      ) 
      }
    </div>
  );
};

export default InventoryReport;
